export const NEWSLETTER_CONSENT_VERSION = '2026-09-10';
export const NEWSLETTER_CONSENT_TEXT = 'Ich möchte per E-Mail Produktneuigkeiten und Angebote von Einfach-Trading erhalten, auch nach Ende meiner App-Nutzung. Jederzeit abbestellbar.';
